import { OpenRequestsCellView, ClosedRequestsCellView } from './main';

export const OpenRequestsCell = OpenRequestsCellView;

export const ClosedRequestsCell = ClosedRequestsCellView;
